var React = require('react');

function DropdownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.707 7.293a1 1 0 0 1 0 1.414L12 18.414 2.293 8.707a1 1 0 0 1 1.414-1.414L12 15.586l8.293-8.293a1 1 0 0 1 1.414 0z","fill":"#fff","opacity":".25"}));
}

DropdownArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DropdownArrow;

DropdownArrow.default = DropdownArrow;
